import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type WarningPayload = {
  id: string
  showCurrencyWarning: boolean
}

const initialState: WarningPayload[] = []

const showCurrencyWarningSlice = createSlice({
  name: 'showCurrencyWarning',
  initialState,
  reducers: {
    toggleCurrencyWarning(state, action: PayloadAction<WarningPayload>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
  },
})

export const { toggleCurrencyWarning } = showCurrencyWarningSlice.actions
export default showCurrencyWarningSlice.reducer
